import { render } from "./approveContractParts.vue?vue&type=template&id=5590135a"
import script from "./approveContractParts.vue?vue&type=script&lang=js"
export * from "./approveContractParts.vue?vue&type=script&lang=js"

import "./approveContractParts.vue?vue&type=style&index=0&id=5590135a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__